


// import React, { useEffect, useState } from "react";
// import {
//   Layout,
//   Row,
//   Col,
//   Card,
//   Typography,
//   Avatar,
//   Tag,
//   Button,
//   Spin,
//   Divider,
//   Select,
//   message,
// } from "antd";
// import {
//   UserOutlined,
//   PictureOutlined,
//   CheckCircleOutlined,
//   ClockCircleOutlined,
//   EyeOutlined,
//   CrownOutlined,
// } from "@ant-design/icons";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import LogoUpload from "../Components/LogoUpload";
// import ExtensionTimer from "../Components/ExtensionTimer";
// import { BASE_URL } from "../Config";
// import PaymentModal from "../Components/PaymentModal";
// import CreatorAwards from "../Components/Creatorawards";
// import FollowerBonus from "../Components/FollowerBonus";

// const { Content } = Layout;
// const { Title, Text } = Typography;
// const { Option } = Select;

// const getFullUrl = (url) => {
//   if (!url) return null;
//   if (url.startsWith("http")) return url;
//   return `${BASE_URL.replace("/api", "")}${url}`;
// };

// const MainDashboard = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [user, setUser] = useState(null);
//   const [stats, setStats] = useState({
//     total: 0,
//     approved: 0,
//     pending: 0,
//     rejected: 0,
//   });
//   const [paymentOpen, setPaymentOpen] = useState(false);

//   const navigate = useNavigate();

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   const fetchProfile = async () => {
//     try {
//       setLoading(true);
//       const token = sessionStorage.getItem("token");
//       const res = await axios.get(`${BASE_URL}/users/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (res.data.success) setUser(res.data.data);
//     } catch (err) {
//       if (err.response?.status === 401) {
//         sessionStorage.removeItem("token");
//         navigate("/login");
//       } else {
//         message.error("Failed to load profile.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchStats = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       const res = await axios.get(`${BASE_URL}/uservariations/mystats`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (res.data.success) setStats(res.data.data);
//     } catch (err) {
//       console.error("Stats fetch error:", err);
//     }
//   };

//   useEffect(() => {
//     const token = sessionStorage.getItem("token");
//     if (!token) { navigate("/login"); return; }
//     fetchProfile();
//     fetchStats();
//   }, []);

//   const handleLogoChange = (newUrl) => {
//     setUser((prev) => ({ ...prev, logoUrl: newUrl }));
//   };

//   if (loading) {
//     return (
//       <div style={{ display: "flex", justifyContent: "center", marginTop: 100 }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       {/* Sidebar */}
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//         role="user"
//       />

//       {/* Main area */}
//       <Layout
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "margin 0.3s",
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "100vh",
//         }}
//       >
//         {/* ── Page content ── */}
//         <Content style={{ padding: isMobile ? 12 : 24, flex: 1 }}>

//           {/* Page title row */}
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "flex-start",
//               marginBottom: 20,
//             }}
//           >
//             <div>
//               <Title level={4} style={{ margin: 0 }}>
//                 Welcome back, {user?.name} 👋
//               </Title>
//               <Text type="secondary">Here's what's happening with your account today.</Text>
//             </div>
//             <Select
//               defaultValue="thisMonth"
//               style={{ width: 140 }}
//               suffixIcon={null}
//             >
//               <Option value="thisMonth">📅 This Month</Option>
//               <Option value="lastMonth">Last Month</Option>
//               <Option value="allTime">All Time</Option>
//             </Select>
//           </div>

//           {/* ── Main two-column grid ── */}
//           <Row gutter={[20, 20]}>

//             {/* ══ LEFT COLUMN ══ */}
//             <Col xs={24} lg={8}>

//               {/* Profile card */}
//               <Card
//                 style={{ borderRadius: 16, overflow: "hidden", padding: 0 }}
//                 bodyStyle={{ padding: 0 }}
//               >
//                 {/* Purple banner */}
//                 <div
//                   style={{
//                     background: "linear-gradient(135deg, #6d28d9 0%, #7c3aed 100%)",
//                     height: 100,
//                     display: "flex",
//                     alignItems: "flex-end",
//                     justifyContent: "center",
//                     paddingBottom: 0,
//                     position: "relative",
//                   }}
//                 >
//                   {/* Avatar sits on the banner boundary */}
//                   <div
//                     style={{
//                       position: "absolute",
//                       bottom: -45,
//                       left: "50%",
//                       transform: "translateX(-50%)",
//                     }}
//                   >
//                     {user?.logoUrl ? (
//                       <img
//                         src={getFullUrl(user.logoUrl)}
//                         alt="Profile"
//                         style={{
//                           width: 90,
//                           height: 90,
//                           borderRadius: "50%",
//                           objectFit: "cover",
//                           border: "3px solid #fff",
//                         }}
//                       />
//                     ) : (
//                       <Avatar
//                         size={90}
//                         icon={<UserOutlined />}
//                         style={{
//                           background: "#eef2ff",
//                           color: "#7c3aed",
//                           border: "3px solid #fff",
//                         }}
//                       />
//                     )}
//                   </div>
//                 </div>

//                 {/* Name / email / logo status */}
//                 <div style={{ textAlign: "center", padding: "56px 20px 16px" }}>
//                   <Title level={5} style={{ margin: 0 }}>{user?.name}</Title>
//                   <Text type="secondary" style={{ fontSize: 13 }}>{user?.email}</Text>
//                   <div style={{ marginTop: 10 }}>
//                     <Tag
//                       color={
//                         user?.logoStatus === "active" ? "green"
//                           : user?.logoStatus === "pending" ? "orange"
//                           : "default"
//                       }
//                       style={{ borderRadius: 20, fontWeight: 600 }}
//                     >
//                       • Logo:{" "}
//                       {user?.logoStatus === "active"
//                         ? "Active"
//                         : user?.logoStatus === "pending"
//                         ? "Processing"
//                         : "Not set"}
//                     </Tag>
//                   </div>
//                 </div>

//                 <Divider style={{ margin: "0 0 12px" }} />

//                 {/* Logo upload */}
//                 <div style={{ padding: "0 20px 16px" }}>
//                   <LogoUpload
//                     currentLogoUrl={user?.logoUrl}
//                     onLogoChange={handleLogoChange}
//                   />
//                 </div>
//               </Card>

//               {/* Media Link Extension card */}
//               <Card
//                 style={{
//                   borderRadius: 16,
//                   marginTop: 16,
//                   background: "#fffbeb",
//                   border: "1px solid #fde68a",
//                 }}
//               >
//                 <ExtensionTimer />
//               </Card>
//             </Col>

//             {/* ══ RIGHT COLUMN ══ */}
//             <Col xs={24} lg={16}>

//               {/* Stat cards row */}
//               <Row gutter={[12, 12]}>
//                 {/* Total Images */}
//                 <Col xs={12} sm={6}>
//                   <Card style={{ borderRadius: 14, textAlign: "left" }} bodyStyle={{ padding: 16 }}>
//                     <Avatar
//                       size={42}
//                       icon={<PictureOutlined />}
//                       style={{ background: "#ede9fe", color: "#7c3aed", marginBottom: 10 }}
//                     />
//                     <div style={{ fontSize: 13, color: "#888" }}>Total Images</div>
//                     <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2 }}>{stats.total}</div>
//                     <Divider style={{ margin: "10px 0 6px" }} />
//                     <Text type="secondary" style={{ fontSize: 11 }}>All uploaded images</Text>
//                   </Card>
//                 </Col>

//                 {/* Approved */}
//                 <Col xs={12} sm={6}>
//                   <Card style={{ borderRadius: 14, textAlign: "left" }} bodyStyle={{ padding: 16 }}>
//                     <Avatar
//                       size={42}
//                       icon={<CheckCircleOutlined />}
//                       style={{ background: "#d1fae5", color: "#10b981", marginBottom: 10 }}
//                     />
//                     <div style={{ fontSize: 13, color: "#888" }}>Approved</div>
//                     <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2 }}>{stats.approved}</div>
//                     <Divider style={{ margin: "10px 0 6px" }} />
//                     <Text type="secondary" style={{ fontSize: 11 }}>Ready to use</Text>
//                   </Card>
//                 </Col>

//                 {/* Pending */}
//                 <Col xs={12} sm={6}>
//                   <Card style={{ borderRadius: 14, textAlign: "left" }} bodyStyle={{ padding: 16 }}>
//                     <Avatar
//                       size={42}
//                       icon={<ClockCircleOutlined />}
//                       style={{ background: "#fef3c7", color: "#f59e0b", marginBottom: 10 }}
//                     />
//                     <div style={{ fontSize: 13, color: "#888" }}>Pending</div>
//                     <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2 }}>{stats.pending}</div>
//                     <Divider style={{ margin: "10px 0 6px" }} />
//                     <Text type="secondary" style={{ fontSize: 11 }}>Under review</Text>
//                   </Card>
//                 </Col>

//                 {/* Rejected */}
//                 <Col xs={12} sm={6}>
//                   <Card style={{ borderRadius: 14, textAlign: "left" }} bodyStyle={{ padding: 16 }}>
//                     <Avatar
//                       size={42}
//                       icon={<ClockCircleOutlined />}
//                       style={{ background: "#fee2e2", color: "#ef4444", marginBottom: 10 }}
//                     />
//                     <div style={{ fontSize: 13, color: "#888" }}>Rejected</div>
//                     <div style={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2 }}>{stats.rejected}</div>
//                     <Divider style={{ margin: "10px 0 6px" }} />
//                     <Text type="secondary" style={{ fontSize: 11 }}>Need attention</Text>
//                   </Card>
//                 </Col>
//               </Row>

//               {/* Quick Actions dark card */}
//               <Card
//                 style={{
//                   borderRadius: 16,
//                   marginTop: 16,
//                   background: "#1e1b4b",
//                   border: "none",
//                   overflow: "hidden",
//                   position: "relative",
//                 }}
//                 bodyStyle={{ padding: 24 }}
//               >
//                 {/* Decorative image placeholder (right side) */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     right: 0,
//                     top: 0,
//                     bottom: 0,
//                     width: 180,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     opacity: 0.9,
//                   }}
//                 >
//                   {/* Cloud upload illustration placeholder */}
//                   <div style={{ fontSize: 72, filter: "drop-shadow(0 4px 16px rgba(124,58,237,0.5))" }}>
//                     ☁️
//                   </div>
//                 </div>

//                 <div style={{ position: "relative", zIndex: 1, maxWidth: "calc(100% - 180px)" }}>
//                   <Title level={5} style={{ color: "#fff", margin: "0 0 16px" }}>
//                     ✦ Quick Actions
//                   </Title>

//                   <Row gutter={[12, 12]}>
//                     <Col xs={24} sm={12}>
//                       <Button
//                         block
//                         size="large"
//                         icon={<PictureOutlined />}
//                         onClick={() => navigate("/user-asana-upload")}
//                         style={{
//                           background: "#7c3aed",
//                           borderColor: "#7c3aed",
//                           color: "#fff",
//                           borderRadius: 10,
//                           fontWeight: 600,
//                           height: 48,
//                         }}
//                       >
//                         Upload New Image
//                       </Button>
//                     </Col>
//                     <Col xs={24} sm={12}>
//                       <Button
//                         block
//                         size="large"
//                         icon={<EyeOutlined />}
//                         onClick={() => navigate("/my-variation")}
//                         style={{
//                           background: "#312e81",
//                           borderColor: "#4338ca",
//                           color: "#fff",
//                           borderRadius: 10,
//                           fontWeight: 600,
//                           height: 48,
//                         }}
//                       >
//                         View My Images
//                       </Button>
//                     </Col>
//                     <Col xs={24}>
//                       <Button
//                         block
//                         size="large"
//                         icon={<CrownOutlined />}
//                         onClick={() => setPaymentOpen(true)}
//                         style={{
//                           background: "transparent",
//                           borderColor: "#10b981",
//                           color: "#10b981",
//                           borderRadius: 10,
//                           fontWeight: 700,
//                           height: 48,
//                           fontSize: 15,
//                         }}
//                       >
//                         Extend / Upgrade Plan
//                       </Button>
//                     </Col>
//                   </Row>
//                 </div>
//               </Card>

//               {/* Account Details card */}
//               <Card
//                 style={{ borderRadius: 16, marginTop: 16, position: "relative", overflow: "hidden" }}
//                 bodyStyle={{ padding: 24 }}
//               >
//                 {/* World map background watermark */}
//                 <div
//                   style={{
//                     position: "absolute",
//                     right: 0,
//                     top: 0,
//                     bottom: 0,
//                     width: "50%",
//                     backgroundImage:
//                       "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 400'%3E%3Cellipse cx='400' cy='200' rx='380' ry='190' fill='none' stroke='%23e5e7eb' stroke-width='1'/%3E%3C/svg%3E\")",
//                     backgroundRepeat: "no-repeat",
//                     backgroundPosition: "center",
//                     backgroundSize: "contain",
//                     opacity: 0.5,
//                     pointerEvents: "none",
//                   }}
//                 />

//                 <div style={{ position: "relative", zIndex: 1 }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
//                     <Avatar
//                       size={32}
//                       icon={<UserOutlined />}
//                       style={{ background: "#ede9fe", color: "#7c3aed" }}
//                     />
//                     <Title level={5} style={{ margin: 0 }}>Account Details</Title>
//                   </div>

//                   {[
//                     { label: "Country", value: user?.country },
//                     { label: "Mobile", value: user?.mobileNumber },
//                     {
//                       label: "Member since",
//                       value: user?.createdAt
//                         ? new Date(user.createdAt).toLocaleDateString()
//                         : "—",
//                     },
//                   ].map(({ label, value }, i, arr) => (
//                     <div
//                       key={label}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         padding: "10px 0",
//                         borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
//                       }}
//                     >
//                       <Text type="secondary">{label}</Text>
//                       <Text strong>{value || "—"}</Text>
//                     </div>
//                   ))}
//                 </div>
//               </Card>

//               {/* Creator Awards — has its own card styling internally */}
//               <div style={{ marginTop: 16 }}>
//                 <CreatorAwards />
//               </div>

//               {/* Follower Bonus */}
//               <div style={{ marginTop: 16 }}>
//                 <FollowerBonus />
//               </div>
//             </Col>
//           </Row>
//         </Content>

//         {/* Footer */}
//         <div
//           style={{
//             textAlign: "center",
//             padding: "16px",
//             color: "#aaa",
//             fontSize: 13,
//             borderTop: "1px solid #f0f0f0",
//             background: "#fff",
//           }}
//         >
//           © 2026 YogaRefer.Com | All rights reserved
//         </div>
//       </Layout>

//       <PaymentModal
//         open={paymentOpen}
//         onClose={() => setPaymentOpen(false)}
//         userId={user?._id}
//         userMediaLinkCount={user?.mediaLinkCount ?? 0}
//         onSuccess={() => { fetchProfile(); fetchStats(); }}
//       />
//     </Layout>
//   );
// };

// export default MainDashboard;

import React, { useEffect, useState } from "react";
import {
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Avatar,
  Tag,
  Button,
  Spin,
  Divider,
  Select,
  message,
} from "antd";
import {
  UserOutlined,
  PictureOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  EyeOutlined,
  CrownOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import LogoUpload from "../Components/LogoUpload";
import ExtensionTimer from "../Components/ExtensionTimer";
import { BASE_URL } from "../Config";
import PaymentModal from "../Components/PaymentModal";
import CreatorAwards from "../Components/Creatorawards";
import FollowerBonus from "../Components/FollowerBonus";

const { Content } = Layout;
const { Title, Text } = Typography;
const { Option } = Select;

const getFullUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${BASE_URL.replace("/api", "")}${url}`;
};

const MainDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [stats, setStats] = useState({
    total: 0,
    approved: 0,
    pending: 0,
    rejected: 0,
  });
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [asanaStats, setAsanaStats] = useState({ total: 0, approved: 0, pending: 0, rejected: 0 });

  const navigate = useNavigate();

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) setUser(res.data.data);
    } catch (err) {
      if (err.response?.status === 401) {
        sessionStorage.removeItem("token");
        navigate("/login");
      } else {
        message.error("Failed to load profile.");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchAsanaStats = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const res = await axios.get(`${BASE_URL}/userasanas/stats`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.data.success) setAsanaStats(res.data.data);
  } catch (err) {
    console.error("Asana stats fetch error:", err);
  }
};

  const fetchStats = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/uservariations/mystats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) setStats(res.data.data);
    } catch (err) {
      console.error("Stats fetch error:", err);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) { navigate("/login"); return; }
    fetchProfile();
    fetchStats();
    fetchAsanaStats();
  }, []);

  const handleLogoChange = (newUrl) => {
    setUser((prev) => ({ ...prev, logoUrl: newUrl }));
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 100 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      {/* Sidebar */}
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="user"
      />

      {/* Main area */}
      <Layout
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "margin 0.3s",
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        {/* ── Mobile Top Header Bar (Hamburger + Title) ── */}
        {isMobile && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
              background: "#fff",
              borderBottom: "1px solid #f0f0f0",
              position: "sticky",
              top: 0,
              zIndex: 100,
              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
          >
            {/* Hamburger / breadcrumb toggle */}
            <Button
              type="text"
              icon={<MenuOutlined style={{ fontSize: 20 }} />}
              onClick={() => setMobileOpen(true)}
              style={{
                width: 40,
                height: 40,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 8,
                background: "#f5f3ff",
                color: "#7c3aed",
                border: "none",
              }}
            />
            <Text strong style={{ fontSize: 16, color: "#1e1b4b" }}>
              Dashboard
            </Text>
            {/* Avatar shortcut on the right */}
            <div
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/profile")}
            >
              {user?.logoUrl ? (
                <img
                  src={getFullUrl(user.logoUrl)}
                  alt="Profile"
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #7c3aed",
                  }}
                />
              ) : (
                <Avatar
                  size={36}
                  icon={<UserOutlined />}
                  style={{ background: "#ede9fe", color: "#7c3aed" }}
                />
              )}
            </div>
          </div>
        )}

        {/* ── Page content ── */}
        <Content style={{ padding: isMobile ? 12 : 24, flex: 1 }}>

          {/* Page title row */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 20,
              flexWrap: "wrap",
              gap: 10,
            }}
          >
            <div>
              <Title level={isMobile ? 5 : 4} style={{ margin: 0 }}>
                Welcome back, {user?.name} 👋
              </Title>
              <Text type="secondary" style={{ fontSize: isMobile ? 12 : 14 }}>
                Here's what's happening with your account today.
              </Text>
            </div>
            <Select
              defaultValue="thisMonth"
              style={{ width: isMobile ? "100%" : 140 }}
              suffixIcon={null}
            >
              <Option value="thisMonth">📅 This Month</Option>
              <Option value="lastMonth">Last Month</Option>
              <Option value="allTime">All Time</Option>
            </Select>
          </div>

          {/* ── Main two-column grid ── */}
          <Row gutter={[16, 16]}>

            {/* ══ LEFT COLUMN ══ */}
            <Col xs={24} lg={8}>

              {/* Profile card */}
              <Card
                style={{ borderRadius: 16, overflow: "hidden", padding: 0 }}
                bodyStyle={{ padding: 0 }}
              >
                {/* Purple banner */}
                <div
                  style={{
                    background: "linear-gradient(135deg, #6d28d9 0%, #7c3aed 100%)",
                    height: 90,
                    position: "relative",
                  }}
                >
                  {/* Avatar sits on the banner boundary */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: -45,
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    {user?.logoUrl ? (
                      <img
                        src={getFullUrl(user.logoUrl)}
                        alt="Profile"
                        style={{
                          width: 90,
                          height: 90,
                          borderRadius: "50%",
                          objectFit: "cover",
                          border: "3px solid #fff",
                        }}
                      />
                    ) : (
                      <Avatar
                        size={90}
                        icon={<UserOutlined />}
                        style={{
                          background: "#eef2ff",
                          color: "#7c3aed",
                          border: "3px solid #fff",
                        }}
                      />
                    )}
                  </div>
                </div>

                {/* Name / email / logo status */}
                <div style={{ textAlign: "center", padding: "56px 20px 16px" }}>
                  <Title level={5} style={{ margin: 0 }}>{user?.name}</Title>
                  <Text type="secondary" style={{ fontSize: 13 }}>{user?.email}</Text>
                  <div style={{ marginTop: 10 }}>
                    <Tag
                      color={
                        user?.logoStatus === "active" ? "green"
                          : user?.logoStatus === "pending" ? "orange"
                          : "default"
                      }
                      style={{ borderRadius: 20, fontWeight: 600 }}
                    >
                      • Logo:{" "}
                      {user?.logoStatus === "active"
                        ? "Active"
                        : user?.logoStatus === "pending"
                        ? "Processing"
                        : "Not set"}
                    </Tag>
                  </div>
                </div>

                <Divider style={{ margin: "0 0 12px" }} />

                {/* Logo upload */}
                <div style={{ padding: "0 20px 16px" }}>
                  <LogoUpload
                    currentLogoUrl={user?.logoUrl}
                    onLogoChange={handleLogoChange}
                  />
                </div>
              </Card>

              {/* Media Link Extension card */}
              <Card
                style={{
                  borderRadius: 16,
                  marginTop: 16,
                  background: "#fffbeb",
                  border: "1px solid #fde68a",
                }}
              >
                <ExtensionTimer onExtend={() => setPaymentOpen(true)} />
              </Card>
            </Col>

            {/* ══ RIGHT COLUMN ══ */}
            <Col xs={24} lg={16}>

              {/* Stat cards row */}
              <Row gutter={[10, 10]}>
                {[
                  {
                    icon: <PictureOutlined />,
                    bg: "#ede9fe",
                    color: "#7c3aed",
                    label: "Total Images",
                    value: stats.total + asanaStats.total,
                    sub: "All uploaded images",
                  },
                  {
                    icon: <CheckCircleOutlined />,
                    bg: "#d1fae5",
                    color: "#10b981",
                    label: "Approved",
                    value: stats.approved + asanaStats.approved,
                    sub: "Ready to use",
                  },
                  {
                    icon: <ClockCircleOutlined />,
                    bg: "#fef3c7",
                    color: "#f59e0b",
                    label: "Pending",
                    value: stats.pending + asanaStats.pending,
                    sub: "Under review",
                  },
                  {
                    icon: <ClockCircleOutlined />,
                    bg: "#fee2e2",
                    color: "#ef4444",
                    label: "Rejected",
                    value: stats.rejected + asanaStats.rejected,
                    sub: "Need attention",
                  },
                ].map(({ icon, bg, color, label, value, sub }) => (
                  <Col xs={12} sm={6} key={label}>
                    <Card
                      style={{ borderRadius: 14, textAlign: "left" }}
                      bodyStyle={{ padding: isMobile ? 12 : 16 }}
                    >
                      <Avatar
                        size={isMobile ? 36 : 42}
                        icon={icon}
                        style={{ background: bg, color, marginBottom: 8 }}
                      />
                      <div style={{ fontSize: isMobile ? 11 : 13, color: "#888" }}>{label}</div>
                      <div style={{ fontSize: isMobile ? 22 : 28, fontWeight: 700, lineHeight: 1.2 }}>
                        {value}
                      </div>
                      <Divider style={{ margin: "8px 0 4px" }} />
                      <Text type="secondary" style={{ fontSize: 11 }}>{sub}</Text>
                    </Card>
                  </Col>
                ))}
              </Row>

              {/* Quick Actions dark card */}
              <Card
                style={{
                  borderRadius: 16,
                  marginTop: 16,
                  background: "#1e1b4b",
                  border: "none",
                  overflow: "hidden",
                  position: "relative",
                }}
                bodyStyle={{ padding: isMobile ? 16 : 24 }}
              >
                {/* Decorative cloud — hidden on mobile to avoid overlap */}
                {!isMobile && (
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      bottom: 0,
                      width: 180,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      opacity: 0.9,
                      pointerEvents: "none",
                    }}
                  >
                    <div style={{ fontSize: 72, filter: "drop-shadow(0 4px 16px rgba(124,58,237,0.5))" }}>
                      ☁️
                    </div>
                  </div>
                )}

                {/* Content — full width on mobile, constrained on desktop */}
                <div
                  style={{
                    position: "relative",
                    zIndex: 1,
                    maxWidth: isMobile ? "100%" : "calc(100% - 180px)",
                  }}
                >
                  <Title level={5} style={{ color: "#fff", margin: "0 0 16px" }}>
                    ✦ Quick Actions
                  </Title>

                  <Row gutter={[10, 10]}>
                    <Col xs={24} sm={12}>
                      <Button
                        block
                        size="large"
                        icon={<PictureOutlined />}
                        onClick={() => navigate("/user-page")}
                        style={{
                          background: "#7c3aed",
                          borderColor: "#7c3aed",
                          color: "#fff",
                          borderRadius: 10,
                          fontWeight: 600,
                          height: 48,
                        }}
                      >
                        Upload New Image
                      </Button>
                    </Col>
                   <Col xs={24} sm={12}>
  <a href="https://yogarefer.com/" target="_blank" rel="noopener noreferrer">
    <Button
      block
      size="large"
      icon={<EyeOutlined />}
      style={{
        background: "#312e81",
        borderColor: "#4338ca",
        color: "#fff",
        borderRadius: 10,
        fontWeight: 600,
        height: 48,
      }}
    >
      View My Contributions
    </Button>
  </a>
</Col>
                    <Col xs={24}>
                      <Button
                        block
                        size="large"
                        icon={<CrownOutlined />}
                        onClick={() => setPaymentOpen(true)}
                        style={{
                          background: "transparent",
                          borderColor: "#10b981",
                          color: "#10b981",
                          borderRadius: 10,
                          fontWeight: 700,
                          height: 48,
                          fontSize: 15,
                        }}
                      >
                        Extend / Upgrade Plan
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card>

              {/* Account Details card */}
              <Card
                style={{ borderRadius: 16, marginTop: 16, position: "relative", overflow: "hidden" }}
                bodyStyle={{ padding: isMobile ? 16 : 24 }}
              >
                {/* World map background watermark — desktop only */}
                {!isMobile && (
                  <div
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      bottom: 0,
                      width: "50%",
                      backgroundImage:
                        "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 400'%3E%3Cellipse cx='400' cy='200' rx='380' ry='190' fill='none' stroke='%23e5e7eb' stroke-width='1'/%3E%3C/svg%3E\")",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "contain",
                      opacity: 0.5,
                      pointerEvents: "none",
                    }}
                  />
                )}

                <div style={{ position: "relative", zIndex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                    <Avatar
                      size={32}
                      icon={<UserOutlined />}
                      style={{ background: "#ede9fe", color: "#7c3aed" }}
                    />
                    <Title level={5} style={{ margin: 0 }}>Account Details</Title>
                  </div>

                  {[
                    { label: "Country", value: user?.country },
                    { label: "Mobile", value: user?.mobileNumber },
                    {
                      label: "Member since",
                      value: user?.createdAt
                        ? new Date(user.createdAt).toLocaleDateString()
                        : "—",
                    },
                  ].map(({ label, value }, i, arr) => (
                    <div
                      key={label}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px 0",
                        borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
                      }}
                    >
                      <Text type="secondary">{label}</Text>
                      <Text strong>{value || "—"}</Text>
                    </div>
                  ))}
                </div>
              </Card>

              {/* Creator Awards */}
              <div style={{ marginTop: 16 }}>
                <CreatorAwards />
              </div>

              {/* Follower Bonus */}
              <div style={{ marginTop: 16 }}>
                <FollowerBonus />
              </div>
            </Col>
          </Row>
        </Content>

      </Layout>

      <PaymentModal
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        userId={user?._id}
        userMediaLinkCount={user?.mediaLinkCount ?? 0}
        onSuccess={() => { fetchProfile(); fetchStats(); }}
      />
    </Layout>
  );
};

export default MainDashboard;